const SiteSelectorContainer = () => {
  return null
}

export default SiteSelectorContainer
